export enum InquiryServiceType {
  MOVE_AND_CLEAN = 1,
  MOVE = 2,
  CLEAN = 3,
}
